import { api, authHeader } from "../configs/axiosConfigs";
import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "SolarentOperator"
    ? "/SLN/SolarentOperator/BankReconciliation"
    : "/SLN/Management/BankReconciliation";

const unwrap = (res) => ({
  ok: res?.isSuccess !== false,
  message: res?.message || "",
  data: res?.data,
});

const BankReconciliationApi = {
  getAccountSummary: async (source = "Management", officialBankAccountId) => {
    const q =
      officialBankAccountId != null
        ? `?officialBankAccountId=${officialBankAccountId}`
        : "";
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetAccountSummary${q}`
    );
    return unwrap(res);
  },

  getPendingLines: async (source = "Management", officialBankAccountId) => {
    const q =
      officialBankAccountId != null
        ? `?officialBankAccountId=${officialBankAccountId}`
        : "";
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetPendingLines${q}`
    );
    return {
      ...unwrap(res),
      data: Array.isArray(res?.data) ? res.data : [],
    };
  },

  getRecentLines: async (source = "Management", officialBankAccountId, take = 100) => {
    const params = new URLSearchParams();
    if (officialBankAccountId != null) params.set("officialBankAccountId", officialBankAccountId);
    params.set("take", String(take));
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetRecentLines?${params.toString()}`
    );
    return {
      ...unwrap(res),
      data: Array.isArray(res?.data) ? res.data : [],
    };
  },

  getClassifiedLines: async (source = "Management", officialBankAccountId, take = 500) => {
    const params = new URLSearchParams();
    if (officialBankAccountId != null) params.set("officialBankAccountId", officialBankAccountId);
    params.set("take", String(take));
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetClassifiedLines?${params.toString()}`
    );
    return {
      ...unwrap(res),
      data: Array.isArray(res?.data) ? res.data : [],
    };
  },

  getTransactionTypes: async (source = "Management") => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetTransactionTypes`
    );
    return {
      ...unwrap(res),
      data: Array.isArray(res?.data) ? res.data : [],
    };
  },

  importMellatCsv: async (source = "Management", file, officialBankAccountId) => {
    const formData = new FormData();
    formData.append("file", file, file.name || "mellat.csv");
    const q =
      officialBankAccountId != null
        ? `?officialBankAccountId=${officialBankAccountId}`
        : "";
    const response = await api.request({
      url: `${baseBySource(source)}/ImportMellatCsv${q}`,
      method: "post",
      headers: authHeader(),
      data: formData,
    });
    return unwrap(response?.data ?? response);
  },

  classifyLine: async (source = "Management", payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ClassifyLine`,
      payload
    );
    return unwrap(res);
  },

  revertLineToPending: async (source = "Management", payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/RevertLineToPending`,
      payload
    );
    return unwrap(res);
  },
};

export default BankReconciliationApi;
